export default class InventoryParser {
  static parseInventory(items) {
    const parents = items.filter(item => item.category_id === 2);

    const potentialChildren = items.filter(item =>
      item.category_id !== 2 &&
    item.category_id !== 4 &&
    item.isNotAttached === false);

    const inventory = parents.map(parent => {
      const children = potentialChildren.filter(child => child.posX === parent.posX);

      const formattedChildren = children.map(child => {
        const childObj = {
          inventoryItemId: child.id,
          // thumb: child.thumb, // odkomentuj jeśli potrzebujesz
          posY: child.posY,
          // isReversed: !!child.isReversed,
          // isNotAttached: !!child.isNotAttached
        };

        if (child.posY === 2048.01) {
          childObj.isAdditionalTop = true;
        }

        if (child.id === 33 && parent.width) {
          childObj.width = parent.width - 19;
        }

        return childObj;
      });

      formattedChildren.sort((a, b) => b.posY - a.posY);

      return {
        inventoryItemId: parent.id,
        attachedItems: formattedChildren
      };
    });

    return { inventory };
  }
}
